import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import "../css/paysuccess.css";
import { STORE_CONFIG } from "../config/store";

const copy = {
  success: { title: "Payment return received", body: "You returned from the hosted checkout. This page does not prove that funds have settled; the order must still be verified against the payment provider's server record." },
  cancel: { title: "Payment cancelled", body: "No completion is recorded by this page. Your cart remains available if you want to review it and try again." },
  failed: { title: "Payment could not continue", body: "The checkout did not provide a recognised return state. No payment is confirmed. Please return to your cart or contact support." },
};

const PaySuccess = () => {
  const [searchParams] = useSearchParams();
  const state = searchParams.get("state");
  const result = copy[state] || copy.failed;
  return (
    <main className="successDiv">
      <div className={`success-container payment-${state || "failed"}`}>
        <div className="modal-content">
          <div className="payment-status-mark" aria-hidden="true">{state === "success" ? "✓" : state === "cancel" ? "↩" : "!"}</div>
          <h1>{result.title}</h1><p>{result.body}</p>
          <p>If you need help, email <a href={`mailto:${STORE_CONFIG.supportEmail}`}>{STORE_CONFIG.supportEmail}</a>.</p>
          <div className="payment-actions"><Link to="/cartpage">View cart</Link><Link to="/shop">Continue shopping</Link></div>
        </div>
      </div>
    </main>
  );
};

export default PaySuccess;
